import React, { useEffect, useState } from "react";
import OwlCarousel from 'react-owl-carousel';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import CartImage from '../assets/img/exam/clat.png'

const solvedPapersData = [
  
  {
    logo: CartImage, // Make sure this image is inside the /public directory
    users: '1850.8k Users',
    exam: 'CLAT',
    duration: 'Past 8 year',
    downloads: '2750 Downloads',
    attempts: '953 Test Attempted',
  },
  // You can copy this object for more slides if needed
];

const carouselOptions = {
  loop: true,
  margin: 20,
  autoplay: true,
  autoplayTimeout: 3000,
  autoplayHoverPause: true,
  dots: false,
  nav: false,
  responsive: {
    0: { items: 1 },
    600: { items: 2 },
    1000: { items: 3 },
    1200: { items: 4 },
  },
};

const SolvedQuestionsSection = () => {
  const [testSeriesData1, settestSeriesData1] = useState([]);
  const [loading, setLoading] = useState(true);  // Handle loading state

  const fetchWallOfFame = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getSolvedPreveiousPaper`);
    
      settestSeriesData1(response.data);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWallOfFame();
  }, []); 
  console.log("ffbnfbnfbf mnmnfmnf123",testSeriesData1)
  return (
    <section className="py-4 solved_question">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="site-heading text-left">
              <h2 className="site-title">
                Solved Previous Year Question Papers
                <span> (Solutions Included)</span>
              </h2>
            </div>
          </div>

          <OwlCarousel className="test_series-slider owl-theme" {...carouselOptions}>
            {testSeriesData1.map((item, index) => (
              <div className="test_series" key={index}>
                <div className="tst_logo_wrap">
                  <div className="logo_tst_srs">
                   <img src={`${Image_Base_Url}${item.media_image_path}`} alt="media_image_path" />
                  </div>
                  <div className="usr_count">{item.user_count}</div>
                </div>

                <p className="total_test_wraper pt-3">
                  <span className="tst_wrap_txt">{item.title}</span>
                  {/* <span className="tst_wrap_txt grn_wrap">{item.description}</span> */}
                </p>

                <ul className="pt-3">
                  {/* <li>{item.downloads}</li>
                  <li>{item.attempts}</li> */}
                   <td dangerouslySetInnerHTML={{ __html: item.description }} />
                </ul>

                <a href="#" className="theme-btn">Let’s Get Started</a>
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </section>
  );
};

export default SolvedQuestionsSection;
